var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrenchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6.5,
    stroke: "#217EE2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1438_33302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70707 12.9998C7.83307 13.1258 8.00041 13.1952 8.17841 13.1952C8.35641 13.1952 8.52374 13.1258 8.64974 12.9998L10.0951 11.5545C10.3344 11.6283 10.5836 11.6658 10.8341 11.6655C11.1624 11.6665 11.4877 11.6024 11.7911 11.4768C12.0944 11.3512 12.3699 11.1666 12.6014 10.9338C12.951 10.5853 13.1892 10.1408 13.2861 9.65673C13.3829 9.17266 13.334 8.67074 13.1454 8.21451L12.9554 7.75184L11.5407 9.16617L10.8337 8.45884L12.2481 7.04451L11.7851 6.85417C11.483 6.72982 11.1594 6.66605 10.8327 6.66651C10.1651 6.66651 9.53741 6.92651 9.06574 7.39851C8.7434 7.71978 8.51516 8.12315 8.40575 8.56491C8.29634 9.00666 8.30994 9.46993 8.44507 9.90451L6.99974 11.3498C6.87484 11.4749 6.80469 11.6444 6.80469 11.8212C6.80469 11.9979 6.87484 12.1674 6.99974 12.2925L7.70707 12.9998ZM9.22307 10.0695L9.13841 9.86417C8.99996 9.52963 8.96394 9.16151 9.03492 8.80647C9.10589 8.45143 9.28066 8.12545 9.53707 7.86984C9.72763 7.67804 9.95852 7.53111 10.213 7.43972C10.4674 7.34833 10.739 7.31478 11.0081 7.34151L9.89041 8.45917L11.5401 10.1092L12.6584 8.99084C12.6845 9.26004 12.6506 9.53168 12.5591 9.78621C12.4676 10.0407 12.3209 10.2718 12.1294 10.4628C11.6127 10.9795 10.8081 11.1385 10.1347 10.8615L9.92974 10.7765L8.17841 12.5285H8.17874L8.17841 12.8618V12.5285L7.47107 11.8212L9.22307 10.0695Z",
    fill: "#217EE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1438_33302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchBlue);
export default __webpack_public_path__ + "static/media/wrench-blue.f0783bbae98f0dde102aaae8504da9d5.svg";
export { ForwardRef as ReactComponent };